// Splits `text` around the first occurrence of `highlight`.
// When `highlight` is empty or not found, the whole text is returned as `before`.
const splitHighlight = (text = '', highlight = '') => {
	const index = highlight ? text.indexOf(highlight) : -1;
	if (index === -1) return { before: text, highlight: '', after: '' };
	return {
		before: text.slice(0, index),
		highlight,
		after: text.slice(index + highlight.length),
	};
};

export default splitHighlight;
